import { useContext, useMemo, useState } from 'react';

import InvoiceHistoryTable from './InvoiceHistoryTable';
import BillingService from '@/components/Billing/billing-service';
import { Invoice } from '@/components/Billing/billing-types';
import AppPagination from '@/react_app/common/AppPagination';
// import RouterLink from '@/react_app/common/RouterLink';
import { AppTypography } from '@/react_app/components/Atoms';
import AnimateView from '@/react_app/components/BillingUsage/AnimateView';
import { InvoiceHistoryContextType } from '@/react_app/components/BillingUsage/InvoiceHistory/types';
import { InvoiceHistoryContext } from '@/react_app/components/BillingUsage/contexts';
// import { BILLING_USAGE_HISTORY_ROUTE_NAME } from '@/router/BillingUsage/billing-usage-router.const';

const SettingsUsageBillingInvoiceHistory = () => {
	const { getInvoices } = useContext(InvoiceHistoryContext) as InvoiceHistoryContextType;
	const [invoices, setInvoices] = useState<Invoice[]>([]);
	const invoicesDisplay = useMemo(() => BillingService.getInvoicesDisplay(invoices), [invoices]);
	return (
		<AnimateView>
			<div>
				<AppTypography.Title level={4}>Invoice history</AppTypography.Title>
				{/* <AppTypography.Paragraph className="text-colorTextSecondary text-[13px]">
					See smart upgrade history in{' '}
					<RouterLink to={{ name: BILLING_USAGE_HISTORY_ROUTE_NAME }} className="underline text-inherit">
						usage history
					</RouterLink>
				</AppTypography.Paragraph> */}
				<AppPagination getData={getInvoices} setResults={setInvoices}>
					<InvoiceHistoryTable invoices={invoicesDisplay} class="mt-10" />
				</AppPagination>
			</div>
		</AnimateView>
	);
};

export default SettingsUsageBillingInvoiceHistory;
